<template>
    <div>
      <v-dialog
          v-model="loading.state"
          hide-overlay
          persistent
          width="300"
          style="z-index:20001;"
      >
      <v-card
        :color="loading.color"
        dark
      >
      <v-btn dark class="grey-darken-1" @click="cerrar()">cerrar</v-btn>
        <v-card-text class="pt-3">
          {{loading.titulo}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
        
      </v-card>
      
    </v-dialog>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
export default {
    name:'Loading',
    methods:{
      cerrar(){
        this.ocultarLoading()
      },
      ...mapMutations(['ocultarLoading'])
    },
    computed:{
        ...mapState(['loading']),
    }
}
</script>